import { render } from "./MyScoreLog.vue?vue&type=template&id=1839d8cf"
import script from "./MyScoreLog.vue?vue&type=script&lang=js"
export * from "./MyScoreLog.vue?vue&type=script&lang=js"

import "./MyScoreLog.vue?vue&type=style&index=0&id=1839d8cf&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__